module.exports = "/wwwroot/img/XLS.png?ver=dc2f44ff";